import React from 'react';
import './Home.css';
import draftPresets from '../../data/draftPresets.json';

const Home = ({
  onStartNewDraft,
  onStartPresetDraft,
  onLoadDraft,
  isAuthenticated,
  onLogout,
  username
}) => {
  return (
    <div className="home-view">
      <div className="app-header">
        {isAuthenticated && (
          <div className="user-info">
            <span>Logged in as: {username}</span>
            <button onClick={onLogout} className="logout-button">
              Logout
            </button>
          </div>
        )}
      </div>

      <div className="home-content">
        <div className="welcome-section">
          <h2 nowrap>Useful Chaos' Fantasy Drafter</h2>
          {process.env.REACT_APP_BUILD_DATE && (
            <p className="build-date">Built {process.env.REACT_APP_BUILD_DATE}</p>
          )}
          <p>Create a new draft or load an existing one to get started.</p>
        </div>

        <div className="draft-actions">
          <div className="action-buttons">
            <button
              className="action-button new-draft"
              onClick={onStartNewDraft}
            >
              Start New Draft
            </button>
            <button
              className="action-button load-draft"
              onClick={onLoadDraft}
            >
              Load Draft
            </button>
          </div>

          {draftPresets.length > 0 && (
            <div className="preset-buttons">
              {draftPresets.map((preset) => (
                <button
                  key={preset.name}
                  className="preset-button"
                  onClick={() => onStartPresetDraft(preset)}
                >
                  Start New {preset.name} Draft
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="footer">
        © 2025 - <a href="https://www.usefulchaos.com" target="_blank" rel="noopener noreferrer">UsefulChaos.com</a>
      </div>
    </div>
  );
};

export default Home;